import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
} from '@mui/material';
import { Image } from '@mui/icons-material';
import { Product } from '../../inventory/models/Product';
import { generateUUID } from '../utils/uuid';

const AddProductDialog = ({ open, onClose, onAdd, newProduct, setNewProduct, imagePreview, setImagePreview }) => {
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const base64 = e.target.result.split(',')[1];
        
        // Konwertuj base64 na byte array
        const byteArray = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
        
        // Optymalizuj obrazek przed zapisaniem
        try {
          const optimizedBase64 = await Product.optimizeImage(base64, 150, 150, 0.7);
          
          const optimizedByteArray = Uint8Array.from(atob(optimizedBase64), c => c.charCodeAt(0));
          
          setNewProduct({ 
            ...newProduct, 
            image: {
              data: optimizedByteArray, // Używamy Uint8Array zamiast Array.from()
              contentType: file.type
            }
          });
          setImagePreview(e.target.result); // Pokaż oryginalny obrazek jako podgląd
        } catch (error) {
          console.error('Błąd podczas optymalizacji obrazka:', error);
          // Fallback do oryginalnego obrazka
          setNewProduct({ 
            ...newProduct, 
            image: {
              data: byteArray, // Używamy Uint8Array zamiast Array.from()
              contentType: file.type
            }
          });
          setImagePreview(e.target.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Dodaj nowy produkt</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            fullWidth
            label="External ID"
            value={newProduct.externalId}
            disabled
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <Button
                  size="small"
                  onClick={() => setNewProduct({...newProduct, externalId: generateUUID()})}
                  sx={{ minWidth: 'auto', px: 1 }}
                >
                  Regeneruj
                </Button>
              ),
            }}
          />
          <TextField
            fullWidth
            label="Purchase Price"
            value={newProduct.purchasePrice}
            onChange={(e) => setNewProduct({...newProduct, purchasePrice: e.target.value})}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Nazwa produktu"
            value={newProduct.name}
            onChange={(e) => setNewProduct({...newProduct, name: e.target.value})}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Ilość"
            type="number"
            value={newProduct.quantity}
            onChange={(e) => setNewProduct({...newProduct, quantity: parseInt(e.target.value) || 0})}
            sx={{ mb: 2 }}
          />
          <Button
            variant="outlined"
            component="label"
            startIcon={<Image />}
            sx={{ mb: 2 }}
          >
            Dodaj zdjęcie
            <input
              type="file"
              hidden
              accept="image/*"
              onChange={handleImageUpload}
            />
          </Button>
          {imagePreview && (
            <Box sx={{ mt: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 2, backgroundColor: '#fafafa' }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>Podgląd zdjęcia:</Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <img 
                  src={imagePreview} 
                  alt="Preview" 
                  style={{ 
                    maxWidth: '100%', 
                    maxHeight: '150px', 
                    borderRadius: 8,
                    objectFit: 'contain',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                  }} 
                />
              </Box>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Anuluj
        </Button>
        <Button 
          variant="contained" 
          onClick={onAdd}
          disabled={!newProduct.purchasePrice || !newProduct.name}
        >
          Dodaj produkt
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddProductDialog; 